// src/pages/DataTeam/DataTeamDeploymentList.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import TitleWithBack from '../../components/common/TitleWithBack';
import { FaDatabase, FaBook, FaPlay } from 'react-icons/fa';
import { saveAs } from 'file-saver';
import { useDialog } from '../../context/DialogContext';

export default function DataTeamDeploymentList() {
  const { alert } = useDialog();
  const [seriesList, setSeriesList] = useState([]);
  const [selectedSeries, setSelectedSeries] = useState('');
  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState('');

  const [loadingSeries, setLoadingSeries] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoadingSeries(true);
    axios
      .get('/api/exam-series')
      .then((res) => {
        setSeriesList(res.data || []);
        setLoadingSeries(false);
      })
      .catch(() => {
        setError('Error fetching exam series.');
        setLoadingSeries(false);
      });
  }, []);

  const handleSeriesChange = (e) => {
    const seriesId = e.target.value;
    setSelectedSeries(seriesId);
    setSelectedModule('');
    setModules([]);
    if (!seriesId) return;

    // Find the chosen series, flatten its modules from each program
    const seriesObj = seriesList.find((s) => String(s.id) === seriesId);
    if (!seriesObj) return;

    // If series has programs -> modules, flatten them
    const newModules = [];
    (seriesObj.programs || []).forEach((prog) => {
      (prog.modules || []).forEach((m) => {
        newModules.push({
          id: m.id,
          moduleName: m.moduleName || 'Unknown Module',
          moduleCode: m.moduleCode || ''
        });
      });
    });
    setModules(newModules);
  };

  const handleModuleChange = (e) => {
    setSelectedModule(e.target.value);
  };

  const handleGenerate = async () => {
    if (!selectedSeries || !selectedModule) return;
    try {
      const res = await axios.get(`/api/exam-series/${selectedSeries}/deployment-list?moduleId=${selectedModule}`, { responseType: 'blob' });
      saveAs(res.data, `deployment_list_series_${selectedSeries}_module_${selectedModule}.xlsx`);
    } catch (e) {
      alert('Failed to generate deployment list.', { title: 'Error', variant: 'danger' });
    }
  };

  return (
    <Container className="mt-2" fluid>
      <TitleWithBack title="Generate a deployment list" />
      {error && <p className="text-danger">{error}</p>}
      <Card className="shadow-sm">
        <Card.Body>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>
                <FaDatabase className="me-2" />
                Series
              </Form.Label>
              <Form.Select value={selectedSeries} onChange={handleSeriesChange}>
                <option value="">Select a series</option>
                {loadingSeries && <option>Loading series...</option>}
                {seriesList.map((series) => (
                  <option key={series.id} value={series.id}>
                    {series.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6}>
              <Form.Label>
                <FaBook className="me-2" />
                Module
              </Form.Label>
              <Form.Select value={selectedModule} onChange={handleModuleChange} disabled={!selectedSeries}>
                <option value="">Select a module</option>
                {modules.map((mod) => (
                  <option key={mod.id} value={mod.id}>
                    {mod.moduleName} ({mod.moduleCode})
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          <div className="text-end">
            <Button variant="primary" onClick={handleGenerate} disabled={!selectedSeries || !selectedModule}>
              <FaPlay className="me-2" />
              Generate
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
